<template>
  <el-container id="aDev">
    <el-header style="height:38px;line-height:30px;padding:0;margin:0;background:#F4F4F4">
      <div style="display:flex;white-space: nowrap;">
        <p v-for="l in li_h_text" :style="{color:l.colour,lineHeight:0.3}">{{ l.text }} > </p>
        <p style="color:#000000;line-height:0.3;margin-left:5px">{{ h_text }}</p>
      </div>
    </el-header>
    <el-container class="div_main">
      <!--      <el-header style="height:100px;line-height:30px;padding:0;margin:0;background:#FFFFFF">
              <div style="display:flex;white-space: nowrap;">
                <div style="width:25%">
                  <p style="color:#BCBCBC;line-height:0.3;margin-top:40px">全部设备</p>
                  <p style="color:#000000;line-height:0.3;margin-left:5px">{{ state_all }}个</p>
                </div>
                <el-divider direction="vertical" class="fg_x"></el-divider>
                <div style="width:25%">
                  <p style="color:#BCBCBC;line-height:0.3;margin-top:40px">在线设备</p>
                  <p style="color:#000000;line-height:0.3;margin-left:5px">{{ state_zx }}个</p>
                </div>
                <el-divider direction="vertical" class="fg_x"></el-divider>
                <div style="width:25%">
                  <p style="color:#BCBCBC;line-height:0.3;margin-top:40px">离线设备</p>
                  <p style="color:#000000;line-height:0.3;margin-left:5px">{{ state_lx }}个</p>
                </div>
                <el-divider direction="vertical" class="fg_x"></el-divider>
                <div style="width:25%">
                  <p style="color:#BCBCBC;line-height:0.3;margin-top:40px">故障设备</p>
                  <p style="color:#000000;line-height:0.3;margin-left:5px">{{ state_err }}个</p>
                </div>
              </div>
            </el-header>-->
      <el-main style="background:#FFFFFF;padding:15px;margin-top:10px">
        <div style="display:flex;height:36px;width:100%;line-height:0.3;text-align:left;align-items: center;">
          <!--          <p style="color: #000000;font-weight:bold;">故障上报</p>
                    <p style="color: #1D66DD;margin-left:5px;margin-right:5px;font-weight:bold;">{{ total }}</p>
                    <p style="color: #000000;font-weight:bold;">条</p>-->
          <!--          <span style="margin-left:0;color: #ffffff; font-size: 13px">
                      <el-select v-model="edi_pid" ref='select1'
                                 @visible-change='show_change1'
                                 clearable filterable placeholder="全部类型"
                                 style="width:10vw;">
                        <el-option
                          v-for="item in li_pid"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                            &lt;!&ndash;@click.native="show_table(httpData,roomData)"&ndash;&gt;
                        </el-option>
                      </el-select>
                    </span>-->
          <!--          <span style="margin-left:0;color: #ffffff; font-size: 13px">-->
          <!--            <el-select v-model="edi_state" ref='select2'-->
          <!--                       @visible-change='show_change2'-->
          <!--                       clearable filterable placeholder="设备状态"-->
          <!--                       style="width:10vw;">-->
          <!--              <el-option-->
          <!--                  v-for="item in li_state"-->
          <!--                  :key="item.value"-->
          <!--                  :label="item.label"-->
          <!--                  :value="item.value">-->
          <!--              </el-option>-->
          <!--            </el-select>-->
          <!--          </span>-->
          <!--          <el-date-picker-->
          <!--              style="margin-left:0.5vw;width:15vw"-->
          <!--              v-model="xz_date"-->
          <!--              @change="upDate"-->
          <!--              size="small"-->
          <!--              type="daterange"-->
          <!--              format="yyyy-MM-dd"-->
          <!--              :clearable="false"-->
          <!--              range-separator="至"-->
          <!--              start-placeholder="开始日期"-->
          <!--              end-placeholder="结束日期">-->
          <!--          </el-date-picker>-->
          <span style="margin-left:0.5vw; color: #ffffff; font-size: 13px">
            <el-input
                placeholder="输入设备名称查询"
                style="width:10vw;"
                prefix-icon="el-icon-search"
                clearable
                v-model="scan_name">
            </el-input>
          </span>
          <span style="margin-left:0.5vw; color: #ffffff; font-size: 13px">
            <el-input
                placeholder="输入设备Did查询"
                style="width:10vw;"
                prefix-icon="el-icon-search"
                clearable
                v-model="scan_mac">
            </el-input>
          </span>
        </div>
        <el-table :data=fil_tabData class="tab_adb" :cell-style="tableYs"
                  style="width:100%; font-size:13px; background:#FFFFFF;margin-top:10px"
                  :max-height=maxHeight show-overflow-tooltip
                  :header-cell-style="{'height':'30px','text-align':'center','background':'#F4F4F4','color':'#0dA7C8'}">
          <el-table-column width="01" sortable/>
          <div v-for="(d,item) in this.defHead">
            <el-table-column :key=item :prop=d.val :label=d.key :width="d.w" sortable>
            </el-table-column>
          </div>
        </el-table>
        <el-pagination
            style="float:right; margin-right:0.5vw;margin-top:5px"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange1"
            :current-page="page"
            :page-sizes="[20, 40, 80, 160, 320]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </el-main>
    </el-container>
    <el-dialog
        title="删除提示"
        :visible.sync="daidelDev"
        width="30%">
      <span>确定删除该设备吗？ 删除后将无法找回，请谨慎操作</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="daidelDev = false">取 消</el-button>
        <el-button type="primary" @click=delDev()>确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import moment from "moment/moment";

export default {
  name:"aDev",
  data() {
    return {
      h_text:"故障列表",
      li_h_text:[
        {"text":"设备管理","colour":"#B7B7B7","pages":""}
      ],
      state_all:0,
      state_zx:0,
      state_lx:0,
      state_err:0,
      edi_pid:"",
      li_pid:[], /*角色列表*/
      li_dev:[],
      scan_mac:"",
      scan_name:"",
      page:1,
      total:0,
      pageSize:10,
      maxHeight:window.innerHeight - 225,
      defHead:[
        {'key':"序号",'val':"item","w":"200px"},
        {'key':"设备类型",'val':"devType","w":"auto"},
        {'key':"设备名称",'val':"devName","w":"auto"},
        {'key':"设备Did",'val':"devMac","w":"auto"},
        {'key':"所属区域",'val':"devArea","w":"auto"},
        {'key':"设备状态",'val':"devState","w":"auto"}
      ],
      tabData:[],
      edi_state:"",
      li_state:[],
      post_head:{},
      daidelDev:false,
      xz_date:this.getYesterday()
    };
  },
  methods:{ /*方法存放*/
    upDate() { /*更新时间*/
      console.log(this.formatDateTime(this.xz_date[0],'day'));
      console.log(this.formatDateTime(this.xz_date[1],'day'));
      this.loading = this.$load.service({spinner:"",text:"正在加载中...",background:"rgba(0, 0, 0, 0.3)"});
      this.loading.close();
    },
    tableYs({row,column,rowIndex,columnIndex}) { /*表格文字颜色更换*/
      return 'text-align:center;background:#FFFFFF;color:#828282';
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getDev();
    },
    handleCurrentChange1(val) {
      this.page = val;
      this.getDev();
    },
    show_change1(item) {
      if (item) {
        this.$refs.select1.focus();
      } else {
        this.$refs.select1.blur();
      }
    },
    show_change2(item) {
      if (item) {
        this.$refs.select2.focus();
      } else {
        this.$refs.select2.blur();
      }
    },
    show_change3(item) {
      if (item) {
        this.$refs.select3.focus();
      } else {
        this.$refs.select3.blur();
      }
    },
    getYesterday() { /*获取昨天时间*/
      return [
        new Date(moment().subtract(1,'day').format('YYYY-MM-DD')),
        new Date(moment().subtract(0,'day').format('YYYY-MM-DD'))
      ];
    },
    formatDateTime(date,name) { /*时间解析*/
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hour = date.getHours();
      const minute = date.getMinutes();
      const second = date.getSeconds();
      let data = "";
      switch (name) {
        case "allDate":
          data = `${this.pad(month)}/${this.pad(day)}`;
          break;
        case "day":
          data = `${year}-${this.pad(month)}-${this.pad(day)}`;
          break;
      }
      return data;
    },
    pad(num) {
      return num.toString().padStart(2,'0');
    },
    init_View() {
      this.state_all = 0;
      this.state_zx = 0;
      this.state_lx = 0;
      this.state_err = 0;
      let data = this.li_dev;
      let li_d = [];
      let j = 1;
      for (let i = 0; i < data.length; i ++) {
        console.log(data[i]);
        let d = {
          item:j,
          did:data[i]['did'],
          pid:data[i]['pid'],
          devName:data[i]['name'],
          devMac:data[i]['did'],
          statusId:data[i]['statusId'],
          roomId:data[i]['roomId']
        };
        if (data[i]['roomId']) {
          d['floorId'] = data[i]['room']['floorId'];
          if (data[i]['room']['floor']) {
            d['buildId'] = data[i]['room']['floor']['buildingId'];
            d['devArea'] = data[i]['room']['floor']['name'] + "-" + data[i]['room']['name'];
            if (data[i]['room']['floor']['building']) {
              d['devArea'] = data[i]['room']['floor']['building']['name'] + "-" + data[i]['room']['floor']['name'] + "-" + data[i]['room']['name'];
            }
          }
        } else if (data[i]['floorId']) {
          d['floorId'] = data[i]['floorId'];
          if (data[i]['floor']) {
            d['buildId'] = data[i]['floor']['buildingId'];
            d['devArea'] = data[i]['floor']['name'];
            if (data[i]['floor']['building']) {
              d['devArea'] = data[i]['floor']['building']['name'] + "-" + data[i]['floor']['name'];
            }
          }
        }
        const aliceItems = this.li_pid.find((fruit) => { /*js快速查找数组--筛选当前tree列表*/
          return fruit['value'] === d.pid;
        });
        this.state_all += 1;
        if (aliceItems !== undefined) {
          d["devType"] = aliceItems["label"];
        }
        if (!d["statusId"]) { /*状态为空时将状态变成离线*/
          d["statusId"] = 2;
          d["devState"] = "离线";
          this.state_err += 1;
        } else {
          const state = this.li_state.find((fruit) => { /*js快速查找数组--筛选当前tree列表*/
            return fruit['value'] === d.statusId;
          });
          console.log(state["label"]);
          if (state !== undefined) {
            d["devState"] = state["label"];
            if (state["label"] === "在线") {
              this.state_zx = 0;
            } else if (state["label"] === "离线") {
              this.state_lx += 1;
            }
            if (state["label"] === "故障") {
              this.state_err += 1;
            }
          }
        }
        li_d.push(d);
        j += 1;
      }
      this.tabData = li_d;
    },
    getPid() {
      const params = {
        'page':this.page,
        'pageSize':1000
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.getPidList,params,headers).then(res => {
        console.log(res.data.data);
        let data = res.data.data.list;
        let l = [];
        for (let i = 0; i < data.length; i ++) {
          let d = {
            value:data[i]['pid'],
            label:data[i]['name']
          };
          l.push(d);
        }
        this.li_pid = l;
        this.getDev();
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取设备类型失败");
        }
      });
    },
    getDevState() {
      const params = {
        'page':1,
        'pageSize':10
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.getDeviceStatusList,params,headers).then(res => {
        let data = res.data.data.list;
        let l = [];
        for (let i = 0; i < data.length; i ++) {
          let d = {
            value:data[i]['id'],
            label:data[i]['name']
          };
          l.push(d);
        }
        this.li_state = l;
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取设备类型失败");
        }
      });
    },
    getDev() {
      const params = {
        'page':this.page,
        'pageSize':this.pageSize,
        'statusId':3,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.getDeviceList,params,headers).then(res => {
        console.log(res.data.data);
        this.li_dev = res.data.data["list"];
        this.total = res.data.data["total"];
        this.init_View();
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取设备信息失败");
        }
      });
    }
  },
  mounted() { /*页面加载时调用*/
    this.$urls.ip = localStorage.getItem("srv_ip");
    // this.getPid()
    this.getDevState();
    this.getDev();
  },
  computed:{  /*定义计算属性-响应数据改变后重新计算*/
    fil_tabData() {
      return this.tabData.filter(item => {
        this.state = true;
        if (this.edi_pid && item.pid !== this.edi_pid) {
          this.state = false;
        }
        if (this.edi_state && item.statusId !== this.edi_state) {
          this.state = false;
        }
        if (this.scan_name && !item.devName.includes(this.scan_name)) {
          this.state = false;
        }
        if (this.scan_mac && !item.devMac.includes(this.scan_mac)) {
          this.state = false;
        }
        return this.state;
      });
    }
  },
  watch:{  /*监听参数变化*/

  },
  beforeDestroy() { /*页面结束时调用*/

  }
};
</script>

<style>
#aDev {
  height: 100vh;
  margin: 0;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 0;
  background: #F4F4F4;
}

.div_main {
  background: #FFFFFF;
  height: auto;
  margin-bottom: 80px;
  border-radius: 5px 5px 5px 5px;
}

/*.el-switch .el-switch__label--left {
  color: #FFFFFF; !* 设置左侧标签背景色 *!
}

.el-switch .el-switch__label--right {
  color: #72767b; !* 设置右侧标签背景色 *!
}*/

.el-divider--vertical { /*分割线样式*/
  margin: 10px 0px 0px 0px; /*上 右 下 左*/
  width: 2px;
  height: 80px;
  background: #F0F0F0;
}

::-webkit-scrollbar {
  width: 8px; /* 滚动条宽度 */
}

::-webkit-scrollbar-thumb {
  border-radius: 10px; /* 滚动条圆角 */
  background-color: #0dA7C8; /* 滚动条颜色 */
}

::-webkit-scrollbar-track {
  border-radius: 8px;
  background-color: #cacaca;
  border: 1px solid #cacaca;
}

</style>



// WEBPACK FOOTER //
// src/pages/gls/glDevErr.vue